export default "__VITE_ASSET__B1fY3BB0__"